import { AllowedFilesWhitelistExtension } from '../types';

export const ALLOWED_EXTENSION_OPTIONS = [
  AllowedFilesWhitelistExtension.Txt,
  AllowedFilesWhitelistExtension.Jpg,
  AllowedFilesWhitelistExtension.Jpeg,
  AllowedFilesWhitelistExtension.Png,
];
